module.exports = __webpack_public_path__ + "static/logo-14e12e6156b9a7a0644edc7954a4d3d9.svg";